// extracted by mini-css-extract-plugin
export default {"dictionaries":"Dictionaries_dictionaries__IGIpz","navCards":"Dictionaries_navCards__mQY5d"};